export default "__VITE_ASSET__C2Y8NjaG__"